import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SubscriptionActivation  {
    _originalTypeClassName = "zAppDevManager.BO.SubscriptionActivation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SubscriptionActivation.translate = translateService;
}
this.Id = null;
this.From = null;
this.To = null;
this.Canceled = false;
this.CancellationComments = null;
this.DateCreated = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
From:any;
To:any;
Canceled:any;
CancellationComments:any;
DateCreated:any;

static SerializeRow(row: any): any{let s = new Domain.SubscriptionActivation();
s.From = Joove.Common.cast(row.get("SubscriptionId"), "Date");
s.To = Joove.Common.cast(row.get("SubscriptionName"), "Date");
s.Canceled = Joove.Common.cast(row.get("Canceled"), "boolean");
s.CancellationComments = Joove.Common.cast(row.get("CancellationComments"), "string");
s.DateCreated = Joove.Common.cast(row.get("DateCreated"), "Date");
return s;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}